// pages/Configuration.jsx
import { useState } from "react";
// import { CgComment, CgMail } from "react-icons/cg";
import ConfigurationFormField from "../../components/Admin/ConfigurationFormField";
import {
  smsConfigFields,
  emailConfigFields,
} from "../../forms/configurationfields";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { scriptRegex } from "../../utils/utils";

const Configuration = () => {
  const [selectedModuleIndex, setSelectedModuleIndex] = useState("1");
  const [smsFormData, setSmsFormData] = useState({});
  const [emailFormData, setEmailFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showHideSMSOtp, setShowHideSMSOtp] = useState(false);

  const templateList = [
    { label: "SMS Config", value: "1", type: "sms" },
    { label: "Email Config", value: "2", type: "email" },
  ];

  const handleInputChange = (name, value) => {
    if (!scriptRegex.test(value)) {
      if (selectedModuleIndex === "1") {
        setSmsFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        setEmailFormData((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(selectedModuleIndex === "1" ? smsFormData : emailFormData);
  };

  return (
    <DashboardLayout pageTitle="Registered Users" mainClass="p-6">
      <div className="p-6">
        <h4 className="text-lg font-semibold mb-4">Configuration</h4>
        <div className="grid grid-cols-12 gap-6">
          {/* Left Side List */}
          <div className="col-span-12 md:col-span-4">
            <div className="bg-white rounded-xl shadow p-4">
              <h5 className="font-semibold mb-3">List</h5>
              <ul>
                {templateList.map((item) => (
                  <li
                    key={item.value}
                    onClick={() => setSelectedModuleIndex(item.value)}
                    className={`flex items-center px-3 py-2 mb-2 rounded-lg cursor-pointer transition ${
                      selectedModuleIndex === item.value
                        ? "bg-btn text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {/* {item.type === "sms" ? (
                    <CgComment className="mr-2" />
                  ) : (
                    <CgMail className="mr-2" />
                  )} */}
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="col-span-12 md:col-span-8">
            <div className="bg-white rounded-xl shadow p-6">
              {selectedModuleIndex === "1" ? (
                <form onSubmit={handleSubmit}>
                  <p className="text-sm mb-4">
                    View and Update your SMS Gateway and Its API Keys
                  </p>
                  {/* SMS Fields */}
                  {smsConfigFields.map((field) => (
                    <ConfigurationFormField
                      key={field.name}
                      field={field}
                      value={smsFormData[field.name]}
                      onChange={handleInputChange}
                      error={errors[field.name]}
                      options={
                        field.isSelect ? [{ value: 1, label: "Provider1" }] : []
                      }
                    />
                  ))}

                  <button
                    type="submit"
                    className="mt-4 px-6 py-2 bg-btn text-white rounded-lg"
                  >
                    Submit
                  </button>
                </form>
              ) : (
                <form onSubmit={handleSubmit}>
                  <p className="text-sm mb-4">
                    View and Update your Email Configurations
                  </p>

                  {/* Email Fields */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {emailConfigFields.map((field) => (
                      <ConfigurationFormField
                        key={field.name}
                        field={field}
                        value={emailFormData[field.name]}
                        onChange={handleInputChange}
                        error={errors[field.name]}
                      />
                    ))}
                  </div>

                  <button
                    type="submit"
                    className="mt-4 px-6 py-2 bg-btn text-white rounded-lg"
                  >
                    Submit
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Configuration;
